import React from "react";

const Message = ({ message }) => {
    return (
        <div className="messageCard">
            {message.isBot ? (
                <div className="botCard">
                    <p
                        style={{
                            paddingLeft: "16px",
                            paddingRight: "10px",
                            fontFamily: "sans-serif",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                            fontWeight: 500
                        }}
                    >
                        {message.text}
                    </p>
                </div>
            ) : (
                <div className="userCard">
                    <p
                        style={{
                            paddingLeft: "16px",
                            paddingRight: "10px",
                            fontFamily: "sans-serif",
                            fontWeight: 500
                        }}
                    >
                        {message.text}
                    </p>
                </div>
            )}
        </div>
    );
};

export default Message;
